/**
 * MUI config module
 * @module config
 */

/** Define module API */
module.exports = {
  /** Use debug mode */
  debug: true
};



//////////////////
// WEBPACK FOOTER
// ./~/muicss/lib/js/config.js
// module id = 1446
// module chunks = 0